import { render, staticRenderFns } from "./dashboardoutline0308.vue?vue&type=template&id=6d266cff&scoped=true&"
import script from "./dashboardoutline0308.vue?vue&type=script&lang=js&"
export * from "./dashboardoutline0308.vue?vue&type=script&lang=js&"
import style0 from "./dashboardoutline0308.vue?vue&type=style&index=0&id=6d266cff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d266cff",
  null
  
)

export default component.exports